module.exports = __webpack_public_path__ + "img/unity.2da10ecc.png";